import styled from "@emotion/styled";
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { DefaultLayout } from "layouts/DefaultLayout";
import { Loader } from "components/Loader/Loader";
import { PrivateRoute } from "components/PrivateRoute/PrivateRoute";
import Manager from "pages/Manager/Manager";
import Report from "pages/Report/Report";
import User from "pages/User/User";
import List from "pages/List/List";

// const UploadPage = lazy(() => import('./pages/UploadPage'));

export const LoaderContainer = styled.div(({ theme }) => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: theme.switch(
    theme.colors.dark.background,
    theme.colors.light.background
  ),
}));

export const AppRoutes = () => (
  <>
    <Suspense
      fallback={
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      }
    >
      <Routes>
        {" "}
        {/* <Route path="/" element={<MainPage />} /> */}
        {/* <div className="app"> */}
        {/* <Route path="/choose" element={<ChooseManager />} />
        <Route path="/super-manager" element={<ExtraManager />} /> */}
        <Route path="/carrier/:id" element={<Manager />} />
        <Route path="/user/:id" element={<User />} />
        <Route path="/" element={<List />} />
        <Route
          path="/dashboard"
          element={<DefaultLayout>Empty</DefaultLayout>}
        />
        {/* <Route path="/support" element={<DefaultLayout>Empty</DefaultLayout>} />
        <Route path="/report" element={<Report />} />
        <Route
          path="/settings"
          element={<DefaultLayout>Empty</DefaultLayout>}
        /> */}
        {/* </div> */}
      </Routes>
    </Suspense>
  </>
);
